import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export function PostNavigation(datas:MonitoringPost):Promise<MonitoringNavigation>{
    return dataFetcher(`monitoring_navigations`, {
        method:'post',
        body:datas
    })
}